import type { HealthLevel, HealthSignal, HealthSummary } from './types'

/** Тяжесть уровня: чем больше, тем хуже. `unknown` хуже `ok`: непроверенное не выдаём за исправное. */
const SEVERITY: Readonly<Record<HealthLevel, number>> = { ok: 0, unknown: 1, degraded: 2, down: 3 }

/** Хуже из двух уровней. */
export const worseLevel = (a: HealthLevel, b: HealthLevel): HealthLevel => (SEVERITY[b] > SEVERITY[a] ? b : a)

/**
 * Сводка экрана: худший уровень из сигналов (down > degraded > unknown > ok). Пустой список — `unknown`: экран ещё
 * ничего не сообщил о связи, и «всё в порядке» было бы неправдой. В оболочке список не пуст — сигнал сервера есть всегда.
 */
export function summarize(signals: readonly HealthSignal[]): HealthSummary {
  if (signals.length === 0) return { level: 'unknown', signals }
  let level: HealthLevel = 'ok'
  for (const signal of signals) level = worseLevel(level, signal.level)
  return { level, signals }
}
